export const FILE_ACTION_DISABLE_TOOLTIP_LABEL =
  'This action is currently disabled';
